function createLinkElement(item) {
    const link = document.createElement('link');
    link.setAttribute('rel', item.rel);
    link.setAttribute('href', item.href);
    if (item.type) {
        link.setAttribute('type', item.type);
    }
    if (item.sizes) {
        link.setAttribute('sizes', item.sizes);
    }
    return link;
}

function loadFavicons(url) {
    const faviconAppleUrlSettings = window.PAGEFAFICON_APPLE;
    const favicon32UrlSettings = window.PAGEFAFICON_32;
    const favicon16UrlSettings = window.PAGEFAFICON_16;
    const iconPath = (url === '/' || url.endsWith('/')) ? url : `${url}/`;

    const links = [
        {
            rel: 'apple-touch-icon',
            href: `${iconPath}${faviconAppleUrlSettings}`,
        },
        {
            rel: 'icon',
            sizes: '32x32',
            type: 'image/png',
            href: `${iconPath}${favicon32UrlSettings}`,
        },
        {
            rel: 'icon',
            sizes: '16x16',
            type: 'image/png',
            href: `${iconPath}${favicon16UrlSettings}`,
        }
    ];

    const promises = links.map(linkObj => new Promise((resolve, reject) => {
        const linkElement = createLinkElement(linkObj);
        document.head.appendChild(linkElement);

        fetch(linkObj.href, { method: 'HEAD' })
            .then(response => {
                if (response.ok) {
                    resolve(linkObj.href);
                } else {
                    reject(new Error(`Favicon не найден: ${linkObj.href}`));
                }
            })
            .catch(() => {
                reject(new Error(`Favicon не доступен: ${linkObj.href}`));
            });
    }));

    return Promise.allSettled(promises);
}

export default loadFavicons;
